 $(document).ready(function () {
   
    // help pages navigation 
        function helpSlider() {
        $(".service-header__links").slick({
          speed: 300,
          variableWidth: true,
          centerMode: false,
          arrows: false,
          mobileFirst: true,
         responsive: [
            {
              breakpoint: 1024,
              settings: "unslick",
            },
            {
              breakpoint: 769,
              settings: "unslick",
            },
          ],
        });
      }

      helpSlider();
           
           
           
   $(window).resize(function () {
    var $windowWidth = $(window).width();
               
     if ($windowWidth < 769) {
      helpSlider();
    }
  });

});